import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { MyRequest } from 'cpnl-common';
import { fetchMyRequest } from './MyRequestSlice';
import { MyRequestContentSelector } from './MyRequestContentSelector';

export function useMyRequest(): AbstractContentState<MyRequest> {
    return useCmsContent(fetchMyRequest, MyRequestContentSelector);
}
